import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { updateRolePermissions } from "../api/roleMasterApi";
import { addSeparator } from "../utils/Util";


const ActiveSessionModal = (props: any) => {
    const { toggle, openModal } = props;
    const dispatch: any = useDispatch();
    const [sessionsList, setSessionList] = useState();
    const clientName = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
    const closeBtn = (
        <img src={require('../assets/img/close_modal.svg').default} onClick={() => { toggle();}} style={{ cursor: 'pointer' }}></img>
    );

    const deactivate = () => {
        dispatch(updateRolePermissions(props.permissionList, props.formData?.roleStatus, props.roleData?.name, props?.formData?.lineOfBusiness));
    }

    const {
        storeActiveSessions
    } = useSelector((state: any) => state.roleMaster);

    useEffect(()=>{
        let sessionList: any = '';
        storeActiveSessions?.map((item: any) => {
            const sessionClients = item?.clients || {};
            const clientIds = Object.keys(sessionClients);
  
            for (const clientId of clientIds) {
              if (sessionClients[clientId] === clientName && !sessionList.includes(item.username)) {
                sessionList = addSeparator(sessionList, item.username)
              }
            }
            return item.username;
        });
        
        setSessionList(sessionList)
    },[storeActiveSessions])
    
    return (
        <Modal isOpen={openModal} toggle={toggle} centered={true} backdrop={'static'}>
            <ModalHeader toggle={toggle} close={closeBtn}></ModalHeader>
            <ModalBody>
                <p style={{color: 'red', display:'flex', justifyContent:'center'}}>
                    Warning !!
                </p>
                <span style={{textAlign:'center', wordBreak:'break-all'}}>
                    System in use with&nbsp;
                    <b>{sessionsList}</b>
                </span>
                <p>
                    Would you like to proceed and deactivate the Role?
                </p>
            </ModalBody>
            <ModalFooter>
                <Button 
                    type='submit' 
                    className="button" 
                    style={{ width: '91px' }}
                    onClick={deactivate}
                >
                    Yes
                </Button>{' '}
                <Button 
                    onClick={() => { toggle();}} 
                    className="resetButton" 
                    style={{ width: '91px' }}
                >
                    No
                </Button>
            </ModalFooter>
            
        </Modal>
    );
}


export default ActiveSessionModal;